import React from 'react';
import './style.css';


const PricingCard = (props) => {
    return (
        <div className="priceCardContainer">
            <div className="pricetagBg_new"  style={{backgroundColor: props.colorCode}}>
                <p className="pricetagText_new">{props.tagText}</p>
            </div>
            {/*<div className="cardSecondContainer">*/}


                 <h3 className="pricecardHeading" style={{color: props.priceColor }}>{props.priceText}</h3>

            <p className="pricecardParagraph">
                {props.ParagraphText}
            </p>


            {/*</div>/\*/}
        </div>
    );
};

export default PricingCard;
